var items = {
  "block.minecraft.air": "hava",
  "block.minecraft.stone": "daş",
  "block.minecraft.granite": "qranit",
  "block.minecraft.polished_granite": "cilalanmış qranit",
  "block.minecraft.diorite": "diorit",
  "block.minecraft.polished_diorite": "cilalanmış diorit",
  "block.minecraft.andesite": "andezit",
  "block.minecraft.polished_andesite": "cilalanmış andezit",
  "block.minecraft.grass_block": "otlu torpaq",
  "block.minecraft.dirt": "torpaq",
  "block.minecraft.coarse_dirt": "cod torpaq",
  "block.minecraft.podzol": "podzol",
  "block.minecraft.crimson_nylium": "al nilium",
  "block.minecraft.warped_nylium": "əyri nilium",
  "block.minecraft.cobblestone": "qırıq daş",
  "block.minecraft.oak_planks": "meşə taxta",
  "block.minecraft.spruce_planks": "ladin taxta",
  "block.minecraft.birch_planks": "ağcaqayın taxta",
  "block.minecraft.jungle_planks": "cəngəllik ağacı taxta",
  "block.minecraft.acacia_planks": "akasiya taxta",
  "block.minecraft.dark_oak_planks": "qara meşə taxta",
  "block.minecraft.crimson_planks": "al taxta",
  "block.minecraft.warped_planks": "əyri taxta",
  "block.minecraft.oak_sapling": "meşə fidanı",
  "block.minecraft.spruce_sapling": "ladin fidanı",
  "block.minecraft.birch_sapling": "ağcaqayın fidanı",
  "block.minecraft.jungle_sapling": "cəngəllik ağacı fidanı",
  "block.minecraft.acacia_sapling": "akasiya fidanı",
  "block.minecraft.dark_oak_sapling": "qara meşə fidanı",
  "block.minecraft.bedrock": "təbəqə qayası",
  "block.minecraft.sand": "qum",
  "block.minecraft.red_sand": "qırmızı qum",
  "block.minecraft.gravel": "çınqıl",
  "block.minecraft.gold_ore": "qızıl filizi",
  "block.minecraft.iron_ore": "dəmir filizi",
  "block.minecraft.coal_ore": "kömür filizi",
  "block.minecraft.nether_gold_ore": "cəhənnəm qızıl filizi",
  "block.minecraft.oak_log": "palıd kötüyü",
  "block.minecraft.spruce_log": "küknar kötüyü",
  "block.minecraft.birch_log": "ağcaqayın kötüyü",
  "block.minecraft.jungle_log": "cəngəllik kötüyü",
  "block.minecraft.acacia_log": "akasiya kötüyü",
  "block.minecraft.dark_oak_log": "qara palıd kötüyü",
  "block.minecraft.crimson_stem": "qırmızı saplaq",
  "block.minecraft.warped_stem": "əyri saplaq",
  "block.minecraft.stripped_oak_log": "soyulmuş palıd kötüyü",
  "block.minecraft.stripped_spruce_log": "soyulmuş küknar kötüyü",
  "block.minecraft.stripped_birch_log": "soyulmuş ağcaqayın kötüyü",
  "block.minecraft.stripped_jungle_log": "soyulmuş cəngəllik kötüyü",
  "block.minecraft.stripped_acacia_log": "soyulmuş akasiya kötüyü",
  "block.minecraft.stripped_dark_oak_log": "soyulmuş qara palıd kötüyü",
  "block.minecraft.stripped_crimson_stem": "soyulmuş al saplaq",
  "block.minecraft.stripped_warped_stem": "soyulmuş əyri saplaq",
  "block.minecraft.stripped_oak_wood": "dubayın ağac odun",
  "block.minecraft.stripped_spruce_wood": "soyulmuş küknar kötüyü",
  "block.minecraft.stripped_birch_wood": "soyulmuş huş kütüğü",
  "block.minecraft.stripped_jungle_wood": "soyulmuş orman ağacı kütüğü",
  "block.minecraft.stripped_acacia_wood": "soyulmuş akasya kütüğü",
  "block.minecraft.stripped_dark_oak_wood": "soyulmuş kara meşe kütüğü",
  "block.minecraft.stripped_crimson_hyphae": "soyulmuş al hifa",
  "block.minecraft.stripped_warped_hyphae": "soyulmuş əyri hifalar",
  "block.minecraft.oak_wood": "palıd odunu",
  "block.minecraft.spruce_wood": "küknar odunu",
  "block.minecraft.birch_wood": "ağcaqayın odunu",
  "block.minecraft.jungle_wood": "cəngəllik ağacı odunu",
  "block.minecraft.acacia_wood": "akasiya odunu",
  "block.minecraft.dark_oak_wood": "qara palıd odunu",
  "block.minecraft.crimson_hyphae": "al hifa",
  "block.minecraft.warped_hyphae": "əyri hifalar",
  "block.minecraft.oak_leaves": "meşə yarpaqları",
  "block.minecraft.spruce_leaves": "ladin yarpaqları",
  "block.minecraft.birch_leaves": "ağcaqayın yarpaqları",
  "block.minecraft.jungle_leaves": "cəngəllik ağacı yarpaqları",
  "block.minecraft.acacia_leaves": "akasiya yarpaqları",
  "block.minecraft.dark_oak_leaves": "qara meşə yarpaqları",
  "block.minecraft.sponge": "süngər",
  "block.minecraft.wet_sponge": "i̇slaq süngər",
  "block.minecraft.glass": "şüşə",
  "block.minecraft.lapis_ore": "lapis lazuli filizi",
  "block.minecraft.lapis_block": "lapis lazuli bloku",
  "block.minecraft.dispenser": "atıcı",
  "block.minecraft.sandstone": "qumdaşı",
  "block.minecraft.chiseled_sandstone": "oyma qumdaşı",
  "block.minecraft.cut_sandstone": "kəsilmiş qum daşı",
  "block.minecraft.note_block": "not bloku",
  "block.minecraft.powered_rail": "gücləndirilmiş rels",
  "block.minecraft.detector_rail": "dedektor rels",
  "block.minecraft.sticky_piston": "yapışqan piston",
  "block.minecraft.cobweb": "hörümçək toru",
  "block.minecraft.grass": "ot",
  "block.minecraft.fern": "qıjı",
  "block.minecraft.dead_bush": "ölü bitki",
  "block.minecraft.seagrass": "dəniz otu",
  "block.minecraft.sea_pickle": "dəniz xiyarı",
  "block.minecraft.piston": "piston",
  "block.minecraft.white_wool": "ağ yun",
  "block.minecraft.orange_wool": "narıncı yun",
  "block.minecraft.magenta_wool": "magenta yun",
  "block.minecraft.light_blue_wool": "açıq göy yun",
  "block.minecraft.yellow_wool": "sarı yun",
  "block.minecraft.lime_wool": "açıq yaşıl yun",
  "block.minecraft.pink_wool": "çəhrayı yun",
  "block.minecraft.gray_wool": "boz yun",
  "block.minecraft.light_gray_wool": "açıq boz yun",
  "block.minecraft.cyan_wool": "mavi yun",
  "block.minecraft.purple_wool": "bənovşəyi yun",
  "block.minecraft.blue_wool": "göy yun",
  "block.minecraft.brown_wool": "qəhvəyi yun",
  "block.minecraft.green_wool": "yaşıl yun",
  "block.minecraft.red_wool": "qırmızı yun",
  "block.minecraft.black_wool": "qara yun",
  "block.minecraft.dandelion": "zəncirotu",
  "block.minecraft.poppy": "xaşxaş",
  "block.minecraft.blue_orchid": "göy orkide",
  "block.minecraft.allium": "xristof soğanı",
  "block.minecraft.azure_bluet": "hüstoniya",
  "block.minecraft.red_tulip": "qırmızı lalə",
  "block.minecraft.orange_tulip": "narıncı lalə",
  "block.minecraft.white_tulip": "ağ lalə",
  "block.minecraft.pink_tulip": "çəhrayı lalə",
  "block.minecraft.oxeye_daisy": "çobanyastığı",
  "block.minecraft.cornflower": "güləvər",
  "block.minecraft.lily_of_the_valley": "may inciçiçəyi",
  "block.minecraft.wither_rose": "wither gülü",
  "block.minecraft.brown_mushroom": "qəhvəyi göbələk",
  "block.minecraft.red_mushroom": "qırmızı göbələk",
  "block.minecraft.crimson_fungus": "al göbələk",
  "block.minecraft.warped_fungus": "əyri göbələk",
  "block.minecraft.crimson_roots": "al köklər",
  "block.minecraft.warped_roots": "əyri köklər",
  "block.minecraft.nether_sprouts": "nezer soğu",
  "block.minecraft.weeping_vines": "ağlayan sarmaşıq",
  "block.minecraft.twisting_vines": "burulmuş sarmaşıq",
  "block.minecraft.sugar_cane": "şəkərqamışı",
  "block.minecraft.kelp": "yosun",
  "block.minecraft.bamboo": "bambuk",
  "block.minecraft.gold_block": "qızıl bloku",
  "block.minecraft.iron_block": "dəmir bloku",
  "block.minecraft.oak_slab": "meşə pillə",
  "block.minecraft.spruce_slab": "ladin pillə",
  "block.minecraft.birch_slab": "ağcaqayın pillə",
  "block.minecraft.jungle_slab": "cəngəllik ağacı pillə",
  "block.minecraft.acacia_slab": "akasiya pillə",
  "block.minecraft.dark_oak_slab": "qara meşə pillə",
  "block.minecraft.crimson_slab": "al pillə",
  "block.minecraft.warped_slab": "əyri pillə",
  "block.minecraft.stone_slab": "daş pillə",
  "block.minecraft.smooth_stone_slab": "düzgün daş pillə",
  "block.minecraft.sandstone_slab": "qumdaşı pillə",
  "block.minecraft.cut_sandstone_slab": "kəsilmiş qum daşı pillə",
  "block.minecraft.petrified_oak_slab": "daşlaşmış palıd pillə",
  "block.minecraft.cobblestone_slab": "qırıq daş pillə",
  "block.minecraft.brick_slab": "kərpic pillə",
  "block.minecraft.stone_brick_slab": "daş kərpic pillə",
  "block.minecraft.nether_brick_slab": "nether kərpici pillə",
  "block.minecraft.quartz_slab": "kvars pillə",
  "block.minecraft.red_sandstone_slab": "qırmızı qumdaşı pillə",
  "block.minecraft.cut_red_sandstone_slab": "kəsilmiş qırmızı qum daşı pillə",
  "block.minecraft.purpur_slab": "purpur pillə",
  "block.minecraft.prismarine_slab": "prizmarin pillə",
  "block.minecraft.prismarine_brick_slab": "prizmarin kərpici pillə",
  "block.minecraft.dark_prismarine_slab": "qara prizmarin pillə",
  "block.minecraft.smooth_quartz": "hamar kvars bloku",
  "block.minecraft.smooth_red_sandstone": "düzgün qırmızı qumdaşı",
  "block.minecraft.smooth_sandstone": "düzgün qumdaşı",
  "block.minecraft.smooth_stone": "hamar daş",
  "block.minecraft.bricks": "kərpic",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "kitab rəfi",
  "block.minecraft.mossy_cobblestone": "mamırlı qırıq daş",
  "block.minecraft.obsidian": "obsidian",
  "block.minecraft.torch": "məşəl",
  "block.minecraft.end_rod": "end çubuğu",
  "block.minecraft.chorus_plant": "nəqarət bitkisi",
  "block.minecraft.chorus_flower": "nəqarət çiçəyi",
  "block.minecraft.purpur_block": "purpur bloku",
  "block.minecraft.purpur_pillar": "purpur stün",
  "block.minecraft.purpur_stairs": "purpur pilləkan",
  "block.minecraft.spawner": "çağırıcı",
  "block.minecraft.oak_stairs": "meşə pilləkan",
  "block.minecraft.chest": "sandıq",
  "block.minecraft.diamond_ore": "almaz filizi",
  "block.minecraft.diamond_block": "almaz bloku",
  "block.minecraft.crafting_table": "hazırlama masası",
  "block.minecraft.farmland": "tarla ərazısı",
  "block.minecraft.furnace": "soba",
  "block.minecraft.ladder": "nərdivan",
  "block.minecraft.rail": "rels",
  "block.minecraft.cobblestone_stairs": "qırıq daş pilləkan",
  "block.minecraft.lever": "ling",
  "block.minecraft.stone_pressure_plate": "daş təyziq təbəqəsi",
  "block.minecraft.oak_pressure_plate": "meşə təyziq təbəqəsi",
  "block.minecraft.spruce_pressure_plate": "ladin təyziq təbəqəsi",
  "block.minecraft.birch_pressure_plate": "ağcaqayın təyziq təbəqəsi",
  "block.minecraft.jungle_pressure_plate": "cəngəllik ağacı təyziq təbəqəsi",
  "block.minecraft.acacia_pressure_plate": "akasiya təyziq təbəqəsi",
  "block.minecraft.dark_oak_pressure_plate": "qara meşə təyziq təbəqəsi",
  "block.minecraft.crimson_pressure_plate": "al təzyiq lövhəsi",
  "block.minecraft.warped_pressure_plate": "əyri təzyiq lövhəsi",
  "block.minecraft.polished_blackstone_pressure_plate": "hamar qaradaş təzyiq lövhəsi",
  "block.minecraft.redstone_ore": "qızıl daş filizi",
  "block.minecraft.redstone_torch": "qızıl daş məşəli",
  "block.minecraft.snow": "qar",
  "block.minecraft.ice": "buz",
  "block.minecraft.snow_block": "qar bloku",
  "block.minecraft.cactus": "kaktus",
  "block.minecraft.clay": "gil",
  "block.minecraft.jukebox": "musiqi qutusu",
  "block.minecraft.oak_fence": "meşə çəpər",
  "block.minecraft.spruce_fence": "ladin çəpər",
  "block.minecraft.birch_fence": "ağcaqayın çəpər",
  "block.minecraft.jungle_fence": "cəngəllik ağacı çəpər",
  "block.minecraft.acacia_fence": "akasiya çəpər",
  "block.minecraft.dark_oak_fence": "qara meşə çəpər",
  "block.minecraft.crimson_fence": "al çəpər",
  "block.minecraft.warped_fence": "əyri çəpər",
  "block.minecraft.pumpkin": "balqabaq",
  "block.minecraft.carved_pumpkin": "oyulmuş balqabaq",
  "block.minecraft.netherrack": "nether daşı",
  "block.minecraft.soul_sand": "ruh qumu",
  "block.minecraft.soul_soil": "ruh torpağı",
  "block.minecraft.basalt": "bazalt",
  "block.minecraft.polished_basalt": "hamar bazalt",
  "block.minecraft.soul_torch": "ruh məşəli",
  "block.minecraft.glowstone": "i̇şıq daşı",
  "block.minecraft.jack_o_lantern": "balqabaq lampası",
  "block.minecraft.oak_trapdoor": "meşə tələ qapısı",
  "block.minecraft.spruce_trapdoor": "ladin tələ qapısı",
  "block.minecraft.birch_trapdoor": "ağcaqayın tələ qapısı",
  "block.minecraft.jungle_trapdoor": "cəngəllik ağacı tələ qapısı",
  "block.minecraft.acacia_trapdoor": "akasiya tələ qapısı",
  "block.minecraft.dark_oak_trapdoor": "qara meşə tələ qapısı",
  "block.minecraft.crimson_trapdoor": "al tələ qapısı",
  "block.minecraft.warped_trapdoor": "əyri tələ qapısı",
  "block.minecraft.infested_stone": "yoluxmuş daş",
  "block.minecraft.infested_cobblestone": "yoluxmuş qırıq daş",
  "block.minecraft.infested_stone_bricks": "yoluxmuş daş kərpic",
  "block.minecraft.infested_mossy_stone_bricks": "yoluxmuş mamırlı daş kərpic",
  "block.minecraft.infested_cracked_stone_bricks": "yoluxmuş çatlamış daş kərpic",
  "block.minecraft.infested_chiseled_stone_bricks": "yoluxmuş oyma daş kərpic",
  "block.minecraft.stone_bricks": "daş kərpic",
  "block.minecraft.mossy_stone_bricks": "mamırlı daş kərpic",
  "block.minecraft.cracked_stone_bricks": "çatlaq daş kərpic",
  "block.minecraft.chiseled_stone_bricks": "oyma daş kərpic",
  "block.minecraft.brown_mushroom_block": "qəhvəyi göbələk bloku",
  "block.minecraft.red_mushroom_block": "qırmızı göbələk bloku",
  "block.minecraft.mushroom_stem": "göbələk sapı",
  "block.minecraft.iron_bars": "dəmir barmaqlıq",
  "block.minecraft.chain": "zəncir",
  "block.minecraft.glass_pane": "i̇ncə şüşə",
  "block.minecraft.melon": "qarpız",
  "block.minecraft.vine": "sarmaşıq",
  "block.minecraft.oak_fence_gate": "meşə çəpər qapısı",
  "block.minecraft.spruce_fence_gate": "ladin çəpər qapısı",
  "block.minecraft.birch_fence_gate": "ağcaqayın çəpər qapısı",
  "block.minecraft.jungle_fence_gate": "cəngəllik ağacı çəpər qapısı",
  "block.minecraft.acacia_fence_gate": "akasiya çəpər qapısı",
  "block.minecraft.dark_oak_fence_gate": "qara meşə çəpər qapısı",
  "block.minecraft.crimson_fence_gate": "al çəpər qapısı",
  "block.minecraft.warped_fence_gate": "əyri çəpər qapısı",
  "block.minecraft.brick_stairs": "kərpic pilləkan",
  "block.minecraft.stone_brick_stairs": "daş kərpic pilləkan",
  "block.minecraft.mycelium": "mitseli",
  "block.minecraft.lily_pad": "suzanbağı",
  "block.minecraft.nether_bricks": "nether kərpici",
  "block.minecraft.cracked_nether_bricks": "çatlamış nezer kərpici",
  "block.minecraft.chiseled_nether_bricks": "naxışlı nezer kərpici",
  "block.minecraft.nether_brick_fence": "nether kərpici çəpər",
  "block.minecraft.nether_brick_stairs": "nether kərpici pilləkan",
  "block.minecraft.enchanting_table": "sehrbazlıq masası",
  "block.minecraft.end_portal_frame": "end portalı strukturu",
  "block.minecraft.end_stone": "end daşı",
  "block.minecraft.end_stone_bricks": "end daşı kərpic",
  "block.minecraft.dragon_egg": "əjdaha yumurtası",
  "block.minecraft.redstone_lamp": "qızıl daş lampası",
  "block.minecraft.sandstone_stairs": "qumdaşı pilləkan",
  "block.minecraft.emerald_ore": "zümrüd filizi",
  "block.minecraft.ender_chest": "ender sandıqı",
  "block.minecraft.tripwire_hook": "tələ qarmağı",
  "block.minecraft.emerald_block": "zümrüd bloku",
  "block.minecraft.spruce_stairs": "ladin pilləkan",
  "block.minecraft.birch_stairs": "ağcaqayın pilləkan",
  "block.minecraft.jungle_stairs": "cəngəllik ağacı pilləkan",
  "block.minecraft.crimson_stairs": "al pilləkən",
  "block.minecraft.warped_stairs": "əyri pilləkən",
  "block.minecraft.command_block": "əmr bloku",
  "block.minecraft.beacon": "mayak",
  "block.minecraft.cobblestone_wall": "qırıq daş divar",
  "block.minecraft.mossy_cobblestone_wall": "mamırlı qırıq daş divarı",
  "block.minecraft.brick_wall": "kərpic divar",
  "block.minecraft.prismarine_wall": "prizmarin divar",
  "block.minecraft.red_sandstone_wall": "qırmızı qumdaşı divar",
  "block.minecraft.mossy_stone_brick_wall": "mamırlı daş kərpic divar",
  "block.minecraft.granite_wall": "qranit divar",
  "block.minecraft.stone_brick_wall": "daş kərpic divar",
  "block.minecraft.nether_brick_wall": "nether kərpici divar",
  "block.minecraft.andesite_wall": "andezit divar",
  "block.minecraft.red_nether_brick_wall": "qırmızı nezer kərpici divarı",
  "block.minecraft.sandstone_wall": "qumdaşı divar",
  "block.minecraft.end_stone_brick_wall": "end daşı kərpici divarı",
  "block.minecraft.diorite_wall": "diorit divar",
  "block.minecraft.blackstone_wall": "qaradaş divar",
  "block.minecraft.polished_blackstone_wall": "hamar qaradaş divar",
  "block.minecraft.polished_blackstone_brick_wall": "hamar qaradaş kərpic divar",
  "block.minecraft.stone_button": "daş düymə",
  "block.minecraft.oak_button": "meşə düymə",
  "block.minecraft.spruce_button": "ladin düymə",
  "block.minecraft.birch_button": "ağcaqayın düymə",
  "block.minecraft.jungle_button": "cəngəllik ağacı düymə",
  "block.minecraft.acacia_button": "akasiya düymə",
  "block.minecraft.dark_oak_button": "qara meşə düymə",
  "block.minecraft.crimson_button": "al düymə",
  "block.minecraft.warped_button": "əyri düymə",
  "block.minecraft.polished_blackstone_button": "hamar qaradaş düymə",
  "block.minecraft.anvil": "dəmirçi zindanı",
  "block.minecraft.chipped_anvil": "çatlamış örs",
  "block.minecraft.damaged_anvil": "sınmış örs",
  "block.minecraft.trapped_chest": "tələli sandıq",
  "block.minecraft.light_weighted_pressure_plate": "həssas ağırlıqlı təyziq təbəqəsi",
  "block.minecraft.heavy_weighted_pressure_plate": "sərt ağırlıqlı təyziq təbəqəsi",
  "block.minecraft.daylight_detector": "gün i̇şığı dedektoru",
  "block.minecraft.redstone_block": "qızıl daş bloku",
  "block.minecraft.nether_quartz_ore": "nether kvarsı filizi",
  "block.minecraft.hopper": "süzgəc",
  "block.minecraft.chiseled_quartz_block": "oyma kvars bloku",
  "block.minecraft.quartz_block": "kvars bloku",
  "block.minecraft.quartz_bricks": "kvars kərpic",
  "block.minecraft.quartz_pillar": "kvars sütun",
  "block.minecraft.quartz_stairs": "kvars pilləkan",
  "block.minecraft.activator_rail": "aktivləyiçi rels",
  "block.minecraft.dropper": "buraxıcı",
  "block.minecraft.white_terracotta": "ağ terrakotta",
  "block.minecraft.orange_terracotta": "narıncı terrakotta",
  "block.minecraft.magenta_terracotta": "macenta terrakotta",
  "block.minecraft.light_blue_terracotta": "açıq göy terrakotta",
  "block.minecraft.yellow_terracotta": "sarı terrakotta",
  "block.minecraft.lime_terracotta": "açıq yaşıl terrakotta",
  "block.minecraft.pink_terracotta": "çəhrayı terrakotta",
  "block.minecraft.gray_terracotta": "boz terrakotta",
  "block.minecraft.light_gray_terracotta": "açıq boz terrakotta",
  "block.minecraft.cyan_terracotta": "firuzəyi terrakotta",
  "block.minecraft.purple_terracotta": "bənövşəyi terrakotta",
  "block.minecraft.blue_terracotta": "göy terrakotta",
  "block.minecraft.brown_terracotta": "qəhvəyi terrakotta",
  "block.minecraft.green_terracotta": "yaşıl terrakotta",
  "block.minecraft.red_terracotta": "qırmızı terrakotta",
  "block.minecraft.black_terracotta": "qara terrakotta",
  "block.minecraft.barrier": "baryer",
  "block.minecraft.iron_trapdoor": "dəmir tələ qapısı",
  "block.minecraft.hay_block": "saman tayası",
  "block.minecraft.white_carpet": "ağ xalça",
  "block.minecraft.orange_carpet": "narıncı xalça",
  "block.minecraft.magenta_carpet": "magenta rəngli xalça",
  "block.minecraft.light_blue_carpet": "açıq göy xalça",
  "block.minecraft.yellow_carpet": "sarı xalça",
  "block.minecraft.lime_carpet": "açıq yaşıl xalça",
  "block.minecraft.pink_carpet": "çəhrayı xalça",
  "block.minecraft.gray_carpet": "boz xalça",
  "block.minecraft.light_gray_carpet": "açıq boz xalça",
  "block.minecraft.cyan_carpet": "mavi xalça",
  "block.minecraft.purple_carpet": "bənövşəyi xalça",
  "block.minecraft.blue_carpet": "göy xalça",
  "block.minecraft.brown_carpet": "qəhvəyi xalça",
  "block.minecraft.green_carpet": "yaşıl xalça",
  "block.minecraft.red_carpet": "qırmızı xalça",
  "block.minecraft.black_carpet": "qara xalça",
  "block.minecraft.terracotta": "terrakotta",
  "block.minecraft.coal_block": "kömür bloku",
  "block.minecraft.packed_ice": "paketlənmiş buz",
  "block.minecraft.acacia_stairs": "akasiya pilləkan",
  "block.minecraft.dark_oak_stairs": "qara meşə pilləkan",
  "block.minecraft.slime_block": "palçıq bloku",
  "block.minecraft.grass_path": "ot yol",
  "block.minecraft.sunflower": "günəbaxan",
  "block.minecraft.lilac": "yasəmən",
  "block.minecraft.rose_bush": "qızılgül kolu",
  "block.minecraft.peony": "pion",
  "block.minecraft.tall_grass": "uzun ot",
  "block.minecraft.large_fern": "i̇ri qıjı",
  "block.minecraft.white_stained_glass": "ağ rəngli şüşə",
  "block.minecraft.orange_stained_glass": "narıncı rəngli şüşə",
  "block.minecraft.magenta_stained_glass": "magenta rəngli şüşə",
  "block.minecraft.light_blue_stained_glass": "açıq göy rəngli şüşə",
  "block.minecraft.yellow_stained_glass": "sarı rəngli şüşə",
  "block.minecraft.lime_stained_glass": "açıq yaşıl rəngli şüşə",
  "block.minecraft.pink_stained_glass": "çəyrayı rəngli şüşə",
  "block.minecraft.gray_stained_glass": "boz rəngli şüşə",
  "block.minecraft.light_gray_stained_glass": "açıq boz rəngli şüşə",
  "block.minecraft.cyan_stained_glass": "mavi rəngli şüşə",
  "block.minecraft.purple_stained_glass": "bənövşəyi rəngli şüşə",
  "block.minecraft.blue_stained_glass": "göy rəngli şüşə",
  "block.minecraft.brown_stained_glass": "qəhvəyi rəngli şüşə",
  "block.minecraft.green_stained_glass": "yaşıl rəngli şüşə",
  "block.minecraft.red_stained_glass": "qırmızı rəngli şüşə",
  "block.minecraft.black_stained_glass": "qara rəngli şüşə",
  "block.minecraft.white_stained_glass_pane": "ağ rəngli i̇ncə şüşə",
  "block.minecraft.orange_stained_glass_pane": "narıncı rəngli i̇ncə şüşə",
  "block.minecraft.magenta_stained_glass_pane": "magenta rəngli i̇ncə şüşə",
  "block.minecraft.light_blue_stained_glass_pane": "açıq göy rəngli i̇ncə şüşə",
  "block.minecraft.yellow_stained_glass_pane": "sarı rəngli i̇ncə şüşə",
  "block.minecraft.lime_stained_glass_pane": "açıq yaşıl rəngli i̇ncə şüşə",
  "block.minecraft.pink_stained_glass_pane": "çəyrayı rəngli i̇ncə şüşə",
  "block.minecraft.gray_stained_glass_pane": "boz rəngli i̇ncə şüşə",
  "block.minecraft.light_gray_stained_glass_pane": "açıq boz rəngli i̇ncə şüşə",
  "block.minecraft.cyan_stained_glass_pane": "mavi rəngli i̇ncə şüşə",
  "block.minecraft.purple_stained_glass_pane": "bənovşəyi rəngli i̇ncə şüşə",
  "block.minecraft.blue_stained_glass_pane": "göy rəngli i̇ncə şüşə",
  "block.minecraft.brown_stained_glass_pane": "qəhvəyi rəngli i̇ncə şüşə",
  "block.minecraft.green_stained_glass_pane": "yaşıl rəngli i̇ncə şüşə",
  "block.minecraft.red_stained_glass_pane": "qırmızı rəngli i̇ncə şüşə",
  "block.minecraft.black_stained_glass_pane": "qara rəngli i̇ncə şüşə",
  "block.minecraft.prismarine": "prizmarin",
  "block.minecraft.prismarine_bricks": "prizmarin kərpici",
  "block.minecraft.dark_prismarine": "qara prizmarin",
  "block.minecraft.prismarine_stairs": "prizmarin pilləkən",
  "block.minecraft.prismarine_brick_stairs": "prizmarin kərpici pilləkan",
  "block.minecraft.dark_prismarine_stairs": "qara prizmarin pilləkən",
  "block.minecraft.sea_lantern": "dəniz fənəri",
  "block.minecraft.red_sandstone": "qırmızı qumdaşı",
  "block.minecraft.chiseled_red_sandstone": "oyma qırmızı qumdaşı",
  "block.minecraft.cut_red_sandstone": "kəsilmiş qırmızı qum daşı",
  "block.minecraft.red_sandstone_stairs": "qırmızı qumdaşı pilləkan",
  "block.minecraft.repeating_command_block": "təkrarlayan əmr bloku",
  "block.minecraft.chain_command_block": "zəncirləmə əmr bloku",
  "block.minecraft.magma_block": "magma bloku",
  "block.minecraft.nether_wart_block": "nezer ziyili bloku",
  "block.minecraft.warped_wart_block": "əyri ziyil bloku",
  "block.minecraft.red_nether_bricks": "qırmızı nether kərpici",
  "block.minecraft.bone_block": "sümük bloku",
  "block.minecraft.structure_void": "struktur boşluğu",
  "block.minecraft.observer": "gözləmçi",
  "block.minecraft.shulker_box": "shulker qutusu",
  "block.minecraft.white_shulker_box": "ağ shulker qutusu",
  "block.minecraft.orange_shulker_box": "narıncı shulker qutusu",
  "block.minecraft.magenta_shulker_box": "magenta shulker qutusu",
  "block.minecraft.light_blue_shulker_box": "açıq göy shulker qutusu",
  "block.minecraft.yellow_shulker_box": "sarı shulker qutusu",
  "block.minecraft.lime_shulker_box": "açıq yaşıl shulker qutusu",
  "block.minecraft.pink_shulker_box": "çəhrayı shulker qutusu",
  "block.minecraft.gray_shulker_box": "boz shulker qutusu",
  "block.minecraft.light_gray_shulker_box": "açıq boz shulker qutusu",
  "block.minecraft.cyan_shulker_box": "mavi shulker qutusu",
  "block.minecraft.purple_shulker_box": "bənövşəyi shulker qutusu",
  "block.minecraft.blue_shulker_box": "göy shulker qutusu",
  "block.minecraft.brown_shulker_box": "qəhvəyi shulker qutusu",
  "block.minecraft.green_shulker_box": "yaşıl shulker qutusu",
  "block.minecraft.red_shulker_box": "qırmızı shulker qutusu",
  "block.minecraft.black_shulker_box": "qara shulker qutusu",
  "block.minecraft.white_glazed_terracotta": "ağ şirli terrakotta",
  "block.minecraft.orange_glazed_terracotta": "narıncı şirli terrakotta",
  "block.minecraft.magenta_glazed_terracotta": "magenta şirli terrakotta",
  "block.minecraft.light_blue_glazed_terracotta": "açıq göy şirli terrakotta",
  "block.minecraft.yellow_glazed_terracotta": "sarı şirli terrakotta",
  "block.minecraft.lime_glazed_terracotta": "laym şirli terrakotta",
  "block.minecraft.pink_glazed_terracotta": "çəhrayı şirli terrakotta",
  "block.minecraft.gray_glazed_terracotta": "boz şirli terrakotta",
  "block.minecraft.light_gray_glazed_terracotta": "açıq boz çirli terrakotta",
  "block.minecraft.cyan_glazed_terracotta": "firuzəyi şirli terrakotta",
  "block.minecraft.purple_glazed_terracotta": "bənövşəyi şirli terrakotta",
  "block.minecraft.blue_glazed_terracotta": "göy şirli terrakotta",
  "block.minecraft.brown_glazed_terracotta": "qəhvəyi şirli terrakotta",
  "block.minecraft.green_glazed_terracotta": "yaşıl şirli terrakotta",
  "block.minecraft.red_glazed_terracotta": "qırmızı şirli terrakotta",
  "block.minecraft.black_glazed_terracotta": "qara şirli terrakotta",
  "block.minecraft.white_concrete": "ağ beton",
  "block.minecraft.orange_concrete": "narıncı beton",
  "block.minecraft.magenta_concrete": "magenta beton",
  "block.minecraft.light_blue_concrete": "açıq göy beton",
  "block.minecraft.yellow_concrete": "sarı beton",
  "block.minecraft.lime_concrete": "açıq yaşıl beton",
  "block.minecraft.pink_concrete": "çəhrayı beton",
  "block.minecraft.gray_concrete": "boz beton",
  "block.minecraft.light_gray_concrete": "açıq boz beton",
  "block.minecraft.cyan_concrete": "mavi beton",
  "block.minecraft.purple_concrete": "bənövşəyi beton",
  "block.minecraft.blue_concrete": "göy beton",
  "block.minecraft.brown_concrete": "qəhvəyi beton",
  "block.minecraft.green_concrete": "yaşıl beton",
  "block.minecraft.red_concrete": "qırmızı beton",
  "block.minecraft.black_concrete": "qara beton",
  "block.minecraft.white_concrete_powder": "ağ sement",
  "block.minecraft.orange_concrete_powder": "narıncı sement",
  "block.minecraft.magenta_concrete_powder": "magenta sement",
  "block.minecraft.light_blue_concrete_powder": "açıq göy sement",
  "block.minecraft.yellow_concrete_powder": "sarı sement",
  "block.minecraft.lime_concrete_powder": "açıq yaşıl sement",
  "block.minecraft.pink_concrete_powder": "çəhrayı sement",
  "block.minecraft.gray_concrete_powder": "boz sement",
  "block.minecraft.light_gray_concrete_powder": "açıq boz sement",
  "block.minecraft.cyan_concrete_powder": "mavi sement",
  "block.minecraft.purple_concrete_powder": "bənövşəyi sement",
  "block.minecraft.blue_concrete_powder": "göy sement",
  "block.minecraft.brown_concrete_powder": "qəhvəyi sement",
  "block.minecraft.green_concrete_powder": "yaşıl sement",
  "block.minecraft.red_concrete_powder": "qırmızı sement",
  "block.minecraft.black_concrete_powder": "qara sement",
  "block.minecraft.turtle_egg": "tısbağa yumurtası",
  "block.minecraft.dead_tube_coral_block": "ölü boru mərcan bloku",
  "block.minecraft.dead_brain_coral_block": "ölü beyin mərcan bloku",
  "block.minecraft.dead_bubble_coral_block": "ölü baloncuk mərcan bloku",
  "block.minecraft.dead_fire_coral_block": "ölü atəş mərcan bloku",
  "block.minecraft.dead_horn_coral_block": "ölü buynuz mərcan bloku",
  "block.minecraft.tube_coral_block": "boru mərcan bloku",
  "block.minecraft.brain_coral_block": "beyin mərcan bloku",
  "block.minecraft.bubble_coral_block": "baloncuk mərcan bloku",
  "block.minecraft.fire_coral_block": "atəş mərcan bloku",
  "block.minecraft.horn_coral_block": "buynuz mərcan bloku",
  "block.minecraft.tube_coral": "boru mərcan",
  "block.minecraft.brain_coral": "beyin mərcan",
  "block.minecraft.bubble_coral": "baloncuk mərcan",
  "block.minecraft.fire_coral": "atəş mərcan",
  "block.minecraft.horn_coral": "buynuz mərcan",
  "block.minecraft.dead_brain_coral": "ölü beyin mərcan",
  "block.minecraft.dead_bubble_coral": "ölü baloncuk mərcan",
  "block.minecraft.dead_fire_coral": "ölü atəş mərcan",
  "block.minecraft.dead_horn_coral": "ölü buynuz mərcan",
  "block.minecraft.dead_tube_coral": "ölü boru mərcan",
  "block.minecraft.tube_coral_fan": "bubble coral fan",
  "block.minecraft.brain_coral_fan": "beyin mərcan",
  "block.minecraft.bubble_coral_fan": "bubble coral fan",
  "block.minecraft.fire_coral_fan": "yanğın mərcan fanatı",
  "block.minecraft.horn_coral_fan": "buynuz mərcan fanat",
  "block.minecraft.dead_tube_coral_fan": "ölü boru mərcan",
  "block.minecraft.dead_brain_coral_fan": "ölü beyin mərcan fanatı",
  "block.minecraft.dead_bubble_coral_fan": "ölü beyin mərcan fanatı",
  "block.minecraft.dead_fire_coral_fan": "ölü yandırmiş mərcan",
  "block.minecraft.dead_horn_coral_fan": "ölü buynuzlu mərcan",
  "block.minecraft.blue_ice": "göy buz",
  "block.minecraft.conduit": "kəmər",
  "block.minecraft.polished_granite_stairs": "cilalanmış qranit pilləkan",
  "block.minecraft.smooth_red_sandstone_stairs": "düzgün qırmızı qumdaşı pilləkan",
  "block.minecraft.mossy_stone_brick_stairs": "mamırlı daş kərpic pilləkan",
  "block.minecraft.polished_diorite_stairs": "cilalanmış diorit pilləkan",
  "block.minecraft.mossy_cobblestone_stairs": "mamırlı qırıq daş pilləkan",
  "block.minecraft.end_stone_brick_stairs": "end daşı kərpici pilləkanı",
  "block.minecraft.stone_stairs": "daş pilləkan",
  "block.minecraft.smooth_sandstone_stairs": "hamar qumdaşı pilləkan",
  "block.minecraft.smooth_quartz_stairs": "hamar kvars pilləkan",
  "block.minecraft.granite_stairs": "qranit pilləkan",
  "block.minecraft.andesite_stairs": "andezit pilləkan",
  "block.minecraft.red_nether_brick_stairs": "qırmızı nezer kərpici pilləkanı",
  "block.minecraft.polished_andesite_stairs": "cilalanmış andezit pilləkan",
  "block.minecraft.diorite_stairs": "diorit pilləkan",
  "block.minecraft.polished_granite_slab": "cilalanmış qranit pillə",
  "block.minecraft.smooth_red_sandstone_slab": "düzgün qırmızı qumdaşı pillə",
  "block.minecraft.mossy_stone_brick_slab": "mamırlı daş kərpic pillə",
  "block.minecraft.polished_diorite_slab": "cilalanmış diorit pillə",
  "block.minecraft.mossy_cobblestone_slab": "mamırlı qırıq daş pillə",
  "block.minecraft.end_stone_brick_slab": "end daşı kərpici pilləsi",
  "block.minecraft.smooth_sandstone_slab": "düzgün qumdaşı pillə",
  "block.minecraft.smooth_quartz_slab": "düzgün kvars pillə",
  "block.minecraft.granite_slab": "qranit pillə",
  "block.minecraft.andesite_slab": "andezit pillə",
  "block.minecraft.red_nether_brick_slab": "qırmızı nezer kərpici pilləsi",
  "block.minecraft.polished_andesite_slab": "cilalanmış andezit pillə",
  "block.minecraft.diorite_slab": "diorit pillə",
  "block.minecraft.scaffolding": "səhnəyə",
  "block.minecraft.iron_door": "dəmir qapı",
  "block.minecraft.oak_door": "meşə qapı",
  "block.minecraft.spruce_door": "ladin qapı",
  "block.minecraft.birch_door": "ağcaqayın qapı",
  "block.minecraft.jungle_door": "cəngəllik ağacı qapı",
  "block.minecraft.acacia_door": "akasiya qapı",
  "block.minecraft.dark_oak_door": "qara meşə qapı",
  "block.minecraft.crimson_door": "al qapı",
  "block.minecraft.warped_door": "əyri qapı",
  "block.minecraft.repeater": "qızıl daş təzələyici",
  "block.minecraft.comparator": "qızıl daş qarşılaşdırıcı",
  "block.minecraft.structure_block": "struktur bloku",
  "block.minecraft.jigsaw": "pazl bloku",
  "item.minecraft.turtle_helmet": "tısbağa qabığı□□başda ikən:□+2 zireh",
  "item.minecraft.scute": "tısbağa pulcuğu",
  "item.minecraft.iron_shovel": "dəmir kürək□□ana əldə ikən:□+3.5 hücüm xəsarəti□-3 hücum sürəti",
  "item.minecraft.iron_pickaxe": "dəmir qazma□□ana əldə ikən:□+3 hücüm xəsarəti□-2.8 hücum sürəti",
  "item.minecraft.iron_axe": "dəmir balta□□ana əldə ikən:□+8 hücüm xəsarəti□-3.1 hücum sürəti",
  "item.minecraft.flint_and_steel": "çaxmax daşı və polad",
  "item.minecraft.apple": "alma",
  "item.minecraft.bow": "yay",
  "item.minecraft.arrow": "ox",
  "item.minecraft.coal": "kömür",
  "item.minecraft.charcoal": "odun kömürü",
  "item.minecraft.diamond": "almaz",
  "item.minecraft.iron_ingot": "dəmir külçə",
  "item.minecraft.gold_ingot": "qızıl külçə",
  "item.minecraft.netherite_ingot": "nezerit külçəsi",
  "item.minecraft.netherite_scrap": "nezerit parçası",
  "item.minecraft.iron_sword": "dəmir qılınc□□ana əldə ikən:□+5 hücüm xəsarəti□-2.4 hücum sürəti",
  "item.minecraft.wooden_sword": "taxta qılınc□□ana əldə ikən:□+3 hücüm xəsarəti□-2.4 hücum sürəti",
  "item.minecraft.wooden_shovel": "taxta kürək□□ana əldə ikən:□+1.5 hücüm xəsarəti□-3 hücum sürəti",
  "item.minecraft.wooden_pickaxe": "taxta qazma□□ana əldə ikən:□+1 hücüm xəsarəti□-2.8 hücum sürəti",
  "item.minecraft.wooden_axe": "taxta balta□□ana əldə ikən:□+6 hücüm xəsarəti□-3.2 hücum sürəti",
  "item.minecraft.stone_sword": "daş qılınc□□ana əldə ikən:□+4 hücüm xəsarəti□-2.4 hücum sürəti",
  "item.minecraft.stone_shovel": "daş kürək□□ana əldə ikən:□+2.5 hücüm xəsarəti□-3 hücum sürəti",
  "item.minecraft.stone_pickaxe": "daş qazma□□ana əldə ikən:□+2 hücüm xəsarəti□-2.8 hücum sürəti",
  "item.minecraft.stone_axe": "daş balta□□ana əldə ikən:□+8 hücüm xəsarəti□-3.2 hücum sürəti",
  "item.minecraft.diamond_sword": "almaz qılınc□□ana əldə ikən:□+6 hücüm xəsarəti□-2.4 hücum sürəti",
  "item.minecraft.diamond_shovel": "almaz kürək□□ana əldə ikən:□+4.5 hücüm xəsarəti□-3 hücum sürəti",
  "item.minecraft.diamond_pickaxe": "almaz qazma□□ana əldə ikən:□+4 hücüm xəsarəti□-2.8 hücum sürəti",
  "item.minecraft.diamond_axe": "almaz balta□□ana əldə ikən:□+8 hücüm xəsarəti□-3 hücum sürəti",
  "item.minecraft.stick": "çubuq",
  "item.minecraft.bowl": "qab",
  "item.minecraft.mushroom_stew": "göbələk pörtləməsi",
  "item.minecraft.golden_sword": "qızıl qılınc□□ana əldə ikən:□+3 hücüm xəsarəti□-2.4 hücum sürəti",
  "item.minecraft.golden_shovel": "qızıl kürək□□ana əldə ikən:□+1.5 hücüm xəsarəti□-3 hücum sürəti",
  "item.minecraft.golden_pickaxe": "qızıl qazma□□ana əldə ikən:□+1 hücüm xəsarəti□-2.8 hücum sürəti",
  "item.minecraft.golden_axe": "qızıl balta□□ana əldə ikən:□+6 hücüm xəsarəti□-3 hücum sürəti",
  "item.minecraft.netherite_sword": "nezerit qılınc□□ana əldə ikən:□+7 hücüm xəsarəti□-2.4 hücum sürəti",
  "item.minecraft.netherite_shovel": "nezerit kürək□□ana əldə ikən:□+5.5 hücüm xəsarəti□-3 hücum sürəti",
  "item.minecraft.netherite_pickaxe": "nezerit qazma□□ana əldə ikən:□+5 hücüm xəsarəti□-2.8 hücum sürəti",
  "item.minecraft.netherite_axe": "nezerit balta□□ana əldə ikən:□+9 hücüm xəsarəti□-3 hücum sürəti",
  "item.minecraft.string": "i̇p",
  "item.minecraft.feather": "tük",
  "item.minecraft.gunpowder": "barıt",
  "item.minecraft.wooden_hoe": "taxta kərki□□ana əldə ikən:□-3 hücum sürəti",
  "item.minecraft.stone_hoe": "daş kərki□□ana əldə ikən:□-2 hücum sürəti",
  "item.minecraft.iron_hoe": "dəmir kərki□□ana əldə ikən:□-1 hücum sürəti",
  "item.minecraft.diamond_hoe": "almaz kərki□□ana əldə ikən:",
  "item.minecraft.golden_hoe": "qızıl kərki□□ana əldə ikən:□-3 hücum sürəti",
  "item.minecraft.netherite_hoe": "nezerit toxa□□ana əldə ikən:",
  "item.minecraft.wheat_seeds": "buğda toxumu",
  "item.minecraft.wheat": "buğda",
  "item.minecraft.bread": "çörək",
  "item.minecraft.leather_helmet": "dəri papaq□□başda ikən:□+1 zireh",
  "item.minecraft.leather_chestplate": "dəri zireh□□gövdədə ikən:□+3 zireh",
  "item.minecraft.leather_leggings": "dəri şalvar□□ayaqda ikən:□+2 zireh",
  "item.minecraft.leather_boots": "dəri ayaqqabı□□ayaqda ikən:□+1 zireh",
  "item.minecraft.chainmail_helmet": "zəncir dəbilqə□□başda ikən:□+2 zireh",
  "item.minecraft.chainmail_chestplate": "zəncir sinəlik□□gövdədə ikən:□+5 zireh",
  "item.minecraft.chainmail_leggings": "zəncir şalvar□□ayaqda ikən:□+4 zireh",
  "item.minecraft.chainmail_boots": "zəncir çəkmə□□ayaqda ikən:□+1 zireh",
  "item.minecraft.iron_helmet": "dəmir dəbilqə□□başda ikən:□+2 zireh",
  "item.minecraft.iron_chestplate": "dəmir sinəlik□□gövdədə ikən:□+6 zireh",
  "item.minecraft.iron_leggings": "dəmir şalvar□□ayaqda ikən:□+5 zireh",
  "item.minecraft.iron_boots": "dəmir çəkmə□□ayaqda ikən:□+2 zireh",
  "item.minecraft.diamond_helmet": "almaz dəbilqə□□başda ikən:□+3 zireh□+2 zireh sərtliyi",
  "item.minecraft.diamond_chestplate": "almaz sinəlik□□gövdədə ikən:□+8 zireh□+2 zireh sərtliyi",
  "item.minecraft.diamond_leggings": "almaz şalvar□□ayaqda ikən:□+6 zireh□+2 zireh sərtliyi",
  "item.minecraft.diamond_boots": "almaz çəkmə□□ayaqda ikən:□+3 zireh□+2 zireh sərtliyi",
  "item.minecraft.golden_helmet": "qızıl dəbilqə□□başda ikən:□+2 zireh",
  "item.minecraft.golden_chestplate": "qızıl sinəlik□□gövdədə ikən:□+5 zireh",
  "item.minecraft.golden_leggings": "qızıl şalvar□□ayaqda ikən:□+3 zireh",
  "item.minecraft.golden_boots": "qızıl çəkmə□□ayaqda ikən:□+1 zireh",
  "item.minecraft.netherite_helmet": "nezerit dəbilqə□□başda ikən:□+3 zireh□+3 zireh sərtliyi□+1 sovrulma dirənci",
  "item.minecraft.netherite_chestplate": "nezerit zireh□□gövdədə ikən:□+8 zireh□+3 zireh sərtliyi□+1 sovrulma dirənci",
  "item.minecraft.netherite_leggings": "nezerit şalvar□□ayaqda ikən:□+6 zireh□+3 zireh sərtliyi□+1 sovrulma dirənci",
  "item.minecraft.netherite_boots": "nezerit çəkmə□□ayaqda ikən:□+3 zireh□+3 zireh sərtliyi□+1 sovrulma dirənci",
  "item.minecraft.flint": "çaxmax daşı",
  "item.minecraft.porkchop": "çiy donuz əti",
  "item.minecraft.cooked_porkchop": "bişmiş donuz əti",
  "item.minecraft.painting": "rəsm",
  "item.minecraft.golden_apple": "qızıl alma",
  "item.minecraft.enchanted_golden_apple": "sehrli qızıl alma",
  "block.minecraft.oak_sign": "palıd lövhə",
  "block.minecraft.spruce_sign": "küknar lövhə",
  "block.minecraft.birch_sign": "ağcaqayın lövhə",
  "block.minecraft.jungle_sign": "cəngəllik ağacı lövhə",
  "block.minecraft.acacia_sign": "akasiya lövhə",
  "block.minecraft.dark_oak_sign": "qara palıd lövhə",
  "block.minecraft.crimson_sign": "al lövhə",
  "block.minecraft.warped_sign": "əyri lövhə",
  "item.minecraft.bucket": "vedrə",
  "item.minecraft.water_bucket": "su vedrəsi",
  "item.minecraft.lava_bucket": "lava vedrəsi",
  "item.minecraft.minecart": "vaqon",
  "item.minecraft.saddle": "yəhər",
  "item.minecraft.redstone": "qızıl daş tozu",
  "item.minecraft.snowball": "qar topu",
  "item.minecraft.oak_boat": "meşə qayıq",
  "item.minecraft.leather": "dəri",
  "item.minecraft.milk_bucket": "süd vedrəsi",
  "item.minecraft.pufferfish_bucket": "kirpi balığı vedrəsi",
  "item.minecraft.salmon_bucket": "salmon vedrəsi",
  "item.minecraft.cod_bucket": "treska vedrəsi",
  "item.minecraft.tropical_fish_bucket": "tropik balıq vedrəsi",
  "item.minecraft.brick": "kərpic",
  "item.minecraft.clay_ball": "gil topu",
  "block.minecraft.dried_kelp_block": "qurudulmuş yosun bloku",
  "item.minecraft.paper": "kağız",
  "item.minecraft.book": "kitab",
  "item.minecraft.slime_ball": "palçıq topu",
  "item.minecraft.chest_minecart": "sandıqlı vaqon",
  "item.minecraft.furnace_minecart": "sobalı vaqon",
  "item.minecraft.egg": "yumurta",
  "item.minecraft.compass": "kompas",
  "item.minecraft.fishing_rod": "tilov",
  "item.minecraft.clock": "saat",
  "item.minecraft.glowstone_dust": "i̇şıq daşı tozu",
  "item.minecraft.cod": "çiy treska",
  "item.minecraft.salmon": "çiy salmon",
  "item.minecraft.tropical_fish": "tropik balıq",
  "item.minecraft.pufferfish": "kirpi balığı",
  "item.minecraft.cooked_cod": "bişmiş treska",
  "item.minecraft.cooked_salmon": "bişmiş salmon",
  "item.minecraft.ink_sac": "mürəkkəb kisəsi",
  "item.minecraft.red_dye": "qırmızı boya",
  "item.minecraft.green_dye": "yaşıl boya",
  "item.minecraft.cocoa_beans": "kakao dənələri",
  "item.minecraft.lapis_lazuli": "lapis lazuli",
  "item.minecraft.purple_dye": "bənövşəyi boya",
  "item.minecraft.cyan_dye": "mavi boya",
  "item.minecraft.light_gray_dye": "açıq boz boya",
  "item.minecraft.gray_dye": "boz boya",
  "item.minecraft.pink_dye": "çəhrayı boya",
  "item.minecraft.lime_dye": "açıq yaşıl boya",
  "item.minecraft.yellow_dye": "sarı boya",
  "item.minecraft.light_blue_dye": "açıq göy boya",
  "item.minecraft.magenta_dye": "magenta boya",
  "item.minecraft.orange_dye": "narıncı boya",
  "item.minecraft.bone_meal": "sümük tozu",
  "item.minecraft.blue_dye": "göy boya",
  "item.minecraft.brown_dye": "qəhvəyi boya",
  "item.minecraft.black_dye": "qara boya",
  "item.minecraft.white_dye": "ağ boya",
  "item.minecraft.bone": "sümük",
  "item.minecraft.sugar": "şəkər",
  "block.minecraft.cake": "tort",
  "block.minecraft.white_bed": "ağ çarpayı",
  "block.minecraft.orange_bed": "narıncı çarpayı",
  "block.minecraft.magenta_bed": "macenta çarpayı",
  "block.minecraft.light_blue_bed": "açıq göy çarpayı",
  "block.minecraft.yellow_bed": "sarı çarpayı",
  "block.minecraft.lime_bed": "açıq yaşıl çarpayı",
  "block.minecraft.pink_bed": "çəhrayı çarpayı",
  "block.minecraft.gray_bed": "boz çarpayı",
  "block.minecraft.light_gray_bed": "açıq boz çarpayı",
  "block.minecraft.cyan_bed": "firuzəyi çarpayı",
  "block.minecraft.purple_bed": "bənövşəyi çarpayı",
  "block.minecraft.blue_bed": "göy çarpayı",
  "block.minecraft.brown_bed": "qəhvəyi çarpayı",
  "block.minecraft.green_bed": "yaşıl çarpayı",
  "block.minecraft.red_bed": "qırmızı çarpayı",
  "block.minecraft.black_bed": "qara çarpayı",
  "item.minecraft.cookie": "kökə",
  "item.minecraft.filled_map": "xəritə□#0",
  "item.minecraft.shears": "qayçı",
  "item.minecraft.melon_slice": "qarpız dilimi",
  "item.minecraft.dried_kelp": "qurudulmuş yosun",
  "item.minecraft.pumpkin_seeds": "balqabaq toxumu",
  "item.minecraft.melon_seeds": "qarpız toxumu",
  "item.minecraft.beef": "çiy i̇nək əti",
  "item.minecraft.cooked_beef": "bifşteks",
  "item.minecraft.chicken": "çiy toyuq əti",
  "item.minecraft.cooked_chicken": "bişmiş toyuq əti",
  "item.minecraft.rotten_flesh": "çürük ət",
  "item.minecraft.ender_pearl": "ender i̇ncisi",
  "item.minecraft.blaze_rod": "bleyz çubuğu",
  "item.minecraft.ghast_tear": "ghast gözyaşı",
  "item.minecraft.gold_nugget": "qızıl parçası",
  "item.minecraft.nether_wart": "nezer ziyili",
  "item.minecraft.potion": "hazırlanmayan eliksir□təsirsiz",
  "item.minecraft.glass_bottle": "şüşə butulka",
  "item.minecraft.spider_eye": "hörümçək gözü",
  "item.minecraft.fermented_spider_eye": "mayalı hörümcək gözü",
  "item.minecraft.blaze_powder": "bleyz tozu",
  "item.minecraft.magma_cream": "magma kremi",
  "block.minecraft.brewing_stand": "eliksir dəzgahı",
  "block.minecraft.cauldron": "qazan",
  "item.minecraft.ender_eye": "ender gözü",
  "item.minecraft.glistering_melon_slice": "parıldayan qapız dilimi",
  "item.minecraft.bat_spawn_egg": "yarasa çağırma yumurtası",
  "item.minecraft.bee_spawn_egg": "arı çağırma yumurtası",
  "item.minecraft.blaze_spawn_egg": "blaze çağırma yumurtası",
  "item.minecraft.cat_spawn_egg": "pişik çağırma yumurtası",
  "item.minecraft.cave_spider_spawn_egg": "mağara hörümcəyi çağırma yumurtası",
  "item.minecraft.chicken_spawn_egg": "toyuq çağırma yumurtası",
  "item.minecraft.cod_spawn_egg": "treska çağırma yumurtası",
  "item.minecraft.cow_spawn_egg": "i̇nək çağırma yumurtası",
  "item.minecraft.creeper_spawn_egg": "kriper çağırma yumurtası",
  "item.minecraft.dolphin_spawn_egg": "delfin çağırma yumurtası",
  "item.minecraft.donkey_spawn_egg": "uzunqulaq çağırma yumurtası",
  "item.minecraft.drowned_spawn_egg": "boğulmuş çağırma yumurtası",
  "item.minecraft.elder_guardian_spawn_egg": "yaşlı mühafizəçi çağırma yumurtası",
  "item.minecraft.enderman_spawn_egg": "endermen çağırma yumurtası",
  "item.minecraft.endermite_spawn_egg": "endermit çağırma yumurtası",
  "item.minecraft.evoker_spawn_egg": "oyadıcı çağırma yumurtası",
  "item.minecraft.fox_spawn_egg": "tülkü çağırma yumurtası",
  "item.minecraft.ghast_spawn_egg": "qast çağırma yumurtası",
  "item.minecraft.guardian_spawn_egg": "mühafizəçi çağırma yumurtası",
  "item.minecraft.hoglin_spawn_egg": "hoqlin çağırma yumurtası",
  "item.minecraft.horse_spawn_egg": "at çağırma yumurtası",
  "item.minecraft.husk_spawn_egg": "hask çağırma yumurtası",
  "item.minecraft.llama_spawn_egg": "lama çağırma yumurtası",
  "item.minecraft.magma_cube_spawn_egg": "maqma kubu çağırma yumurtası",
  "item.minecraft.mooshroom_spawn_egg": "muuşruum çağırma yumurtası",
  "item.minecraft.mule_spawn_egg": "qatır çağırma yumurtası",
  "item.minecraft.ocelot_spawn_egg": "oselot çağırma yumurtası",
  "item.minecraft.panda_spawn_egg": "panda çağırma yumurtası",
  "item.minecraft.parrot_spawn_egg": "tutuquşu çağırma yumurtası",
  "item.minecraft.phantom_spawn_egg": "fantom çağırma yumurtası",
  "item.minecraft.pig_spawn_egg": "donuz çağırma yumurtası",
  "item.minecraft.piglin_spawn_egg": "piqlin çağırma yumurtası",
  "item.minecraft.pillager_spawn_egg": "quldur çağırma yumurtası",
  "item.minecraft.polar_bear_spawn_egg": "qütb ayısı çağırma yumurtası",
  "item.minecraft.pufferfish_spawn_egg": "kirpi balığı çağırma yumurtası",
  "item.minecraft.rabbit_spawn_egg": "dovşan çağırma yumurtası",
  "item.minecraft.ravager_spawn_egg": "dağıdıcı çağırma yumurtası",
  "item.minecraft.salmon_spawn_egg": "qızılbalıq çağırma yumurtası",
  "item.minecraft.sheep_spawn_egg": "qoyun çağırma yumurtası",
  "item.minecraft.shulker_spawn_egg": "şalker çağırma yumurtası",
  "item.minecraft.silverfish_spawn_egg": "gümüşcün çağırma yumurtası",
  "item.minecraft.skeleton_spawn_egg": "skelet çağırma yumurtası",
  "item.minecraft.skeleton_horse_spawn_egg": "skelet at çağırma yumurtası",
  "item.minecraft.slime_spawn_egg": "palçıq çağırma yumurtası",
  "item.minecraft.spider_spawn_egg": "hörümçək çağırma yumurtası",
  "item.minecraft.squid_spawn_egg": "kalmar çağırma yumurtası",
  "item.minecraft.stray_spawn_egg": "strey çağırma yumurtası",
  "item.minecraft.strider_spawn_egg": "strayder çağırma yumurtası",
  "item.minecraft.trader_llama_spawn_egg": "tacir laması çağırma yumurtası",
  "item.minecraft.tropical_fish_spawn_egg": "tropik balıq çağırma yumurtası",
  "item.minecraft.turtle_spawn_egg": "tısbağa çağırma yumurtası",
  "item.minecraft.vex_spawn_egg": "veks çağırma yumurtası",
  "item.minecraft.villager_spawn_egg": "kəndli çağırma yumurtası",
  "item.minecraft.vindicator_spawn_egg": "i̇ntiqamçı çağırma yumurtası",
  "item.minecraft.wandering_trader_spawn_egg": "səyyar tacir çağırma yumurtası",
  "item.minecraft.witch_spawn_egg": "cadugər çağırma yumurtası",
  "item.minecraft.wither_skeleton_spawn_egg": "vizer skeleti çağırma yumurtası",
  "item.minecraft.wolf_spawn_egg": "canavar çağırma yumurtası",
  "item.minecraft.zoglin_spawn_egg": "zoqlin çağırma yumurtası",
  "item.minecraft.zombie_spawn_egg": "zombi çağırma yumurtası",
  "item.minecraft.zombie_horse_spawn_egg": "zombi at çağırma yumurtası",
  "item.minecraft.zombie_villager_spawn_egg": "zombi kəndli çağırma yumurtası",
  "item.minecraft.zombified_piglin_spawn_egg": "zombiləşmiş piqlin çağırma yumurtası",
  "item.minecraft.experience_bottle": "təcrübə eliksiri",
  "item.minecraft.fire_charge": "alov topu",
  "item.minecraft.writable_book": "kitab və tük",
  "item.minecraft.written_book": "yazılı kitab",
  "item.minecraft.emerald": "zümrüd",
  "item.minecraft.item_frame": "əşya çərçivəsi",
  "block.minecraft.flower_pot": "saxsı",
  "item.minecraft.carrot": "yerkökü",
  "item.minecraft.potato": "kartof",
  "item.minecraft.baked_potato": "bişmiş kartof",
  "item.minecraft.poisonous_potato": "zəhərli kartof",
  "item.minecraft.map": "boş xəritə",
  "item.minecraft.golden_carrot": "qızıl yerkökü",
  "block.minecraft.skeleton_skull": "skelet kəlləsi",
  "block.minecraft.wither_skeleton_skull": "wither skeleti kəlləsi",
  "block.minecraft.player_head": "oyunçu başı",
  "block.minecraft.zombie_head": "zombi başı",
  "block.minecraft.creeper_head": "creeper başı",
  "block.minecraft.dragon_head": "əjdaha başı",
  "item.minecraft.carrot_on_a_stick": "yerkökü tilovu",
  "item.minecraft.warped_fungus_on_a_stick": "çubuqlu əyri göbələk",
  "item.minecraft.nether_star": "nether ulduzu",
  "item.minecraft.pumpkin_pie": "balqabaq keksi",
  "item.minecraft.firework_rocket": "fişəng raketi",
  "item.minecraft.firework_star": "fişəng ulduzu",
  "item.minecraft.enchanted_book": "sehrli kitab",
  "item.minecraft.nether_brick": "nether kərpici",
  "item.minecraft.quartz": "nether kvarsı",
  "item.minecraft.tnt_minecart": "tnt-li vaqon",
  "item.minecraft.hopper_minecart": "süzgəcli vaqon",
  "item.minecraft.prismarine_shard": "prizmarin parçası",
  "item.minecraft.prismarine_crystals": "prizmarin kristalı",
  "item.minecraft.rabbit": "çiy dovşan əti",
  "item.minecraft.cooked_rabbit": "bişmiş dovşan əti",
  "item.minecraft.rabbit_stew": "dovşan pörtləməsi",
  "item.minecraft.rabbit_foot": "dovşan ayağı",
  "item.minecraft.rabbit_hide": "dovşan dərisi",
  "item.minecraft.armor_stand": "zireh stendi",
  "item.minecraft.iron_horse_armor": "dəmir at zirehi",
  "item.minecraft.golden_horse_armor": "qızıl at zirehi",
  "item.minecraft.diamond_horse_armor": "almaz at zirehi",
  "item.minecraft.leather_horse_armor": "dəri at zirehi",
  "item.minecraft.lead": "qayış",
  "item.minecraft.name_tag": "ad etiketi",
  "item.minecraft.command_block_minecart": "əmr bloklu vaqon",
  "item.minecraft.mutton": "çiy qoyun əti",
  "item.minecraft.cooked_mutton": "bişmiş qoyun əti",
  "block.minecraft.white_banner": "ağ bayraq",
  "block.minecraft.orange_banner": "narıncı bayraq",
  "block.minecraft.magenta_banner": "magenta bayraq",
  "block.minecraft.light_blue_banner": "açıq göy bayraq",
  "block.minecraft.yellow_banner": "sarı bayraq",
  "block.minecraft.lime_banner": "açıq yaşıl bayraq",
  "block.minecraft.pink_banner": "çəhrayı bayraq",
  "block.minecraft.gray_banner": "boz bayraq",
  "block.minecraft.light_gray_banner": "açıq boz bayraq",
  "block.minecraft.cyan_banner": "mavi bayraq",
  "block.minecraft.purple_banner": "bənövşəyi bayraq",
  "block.minecraft.blue_banner": "göy bayraq",
  "block.minecraft.brown_banner": "qəhvəyi bayraq",
  "block.minecraft.green_banner": "yaşıl bayraq",
  "block.minecraft.red_banner": "qırmızı bayraq",
  "block.minecraft.black_banner": "qara bayraq",
  "item.minecraft.end_crystal": "end kristali",
  "item.minecraft.chorus_fruit": "nəqarət meyvəsi",
  "item.minecraft.popped_chorus_fruit": "partlamış nəqarət meyvəsi",
  "item.minecraft.beetroot": "çuğundur",
  "item.minecraft.beetroot_seeds": "çuğundur toxumu",
  "item.minecraft.beetroot_soup": "çuğundur şorbası",
  "item.minecraft.dragon_breath": "əjdaha nəfəsi",
  "item.minecraft.splash_potion": "atıla bilən hazırlanmayan eliksir□təsirsiz",
  "item.minecraft.spectral_arrow": "spektral ox",
  "item.minecraft.tipped_arrow": "hazırlanmayan eliksirli ox□təsirsiz",
  "item.minecraft.lingering_potion": "daimi hazırlanmayan eliksir□təsirsiz",
  "item.minecraft.shield": "qalxan",
  "item.minecraft.elytra": "qanadüstü",
  "item.minecraft.spruce_boat": "ladin qayıq",
  "item.minecraft.birch_boat": "ağcaqayın qayıq",
  "item.minecraft.jungle_boat": "cəngəllik ağacı qayıq",
  "item.minecraft.acacia_boat": "akasiya qayıq",
  "item.minecraft.dark_oak_boat": "qara meşə qayıq",
  "item.minecraft.totem_of_undying": "ölməmə totemi",
  "item.minecraft.shulker_shell": "shulker qabığı",
  "item.minecraft.iron_nugget": "dəmir parçası",
  "item.minecraft.knowledge_book": "bilik kitabı",
  "item.minecraft.debug_stick": "xəta tapma çubuğu",
  "item.minecraft.music_disc_13": "musiqi diski□c418 - 13",
  "item.minecraft.music_disc_cat": "musiqi diski□c418 - cat",
  "item.minecraft.music_disc_blocks": "musiqi diski□c418 - blocks",
  "item.minecraft.music_disc_chirp": "musiqi diski□c418 - chirp",
  "item.minecraft.music_disc_far": "musiqi diski□c418 - far",
  "item.minecraft.music_disc_mall": "musiqi diski□c418 - mall",
  "item.minecraft.music_disc_mellohi": "musiqi diski□c418 - mellohi",
  "item.minecraft.music_disc_stal": "musiqi diski□c418 - stal",
  "item.minecraft.music_disc_strad": "musiqi diski□c418 - strad",
  "item.minecraft.music_disc_ward": "musiqi diski□c418 - ward",
  "item.minecraft.music_disc_11": "musiqi diski□c418 - 11",
  "item.minecraft.music_disc_wait": "musiqi diski□c418 - wait",
  "item.minecraft.music_disc_pigstep": "musiqi diski□lena rayn - piqstep",
  "item.minecraft.trident": "üçbaşlı əsa□□ana əldə ikən:□+8 hücüm xəsarəti□-2.9 hücum sürəti",
  "item.minecraft.phantom_membrane": "fantom membranı",
  "item.minecraft.nautilus_shell": "nautilus qabığı",
  "item.minecraft.heart_of_the_sea": "dənizin ürəyi",
  "item.minecraft.crossbow": "arbalet",
  "item.minecraft.suspicious_stew": "şübhəli pörtləmə",
  "block.minecraft.loom": "toxucu dəzgahı",
  "item.minecraft.flower_banner_pattern": "banner şablonu□çiçək şəkli",
  "item.minecraft.creeper_banner_pattern": "banner şablonu□kriper şəkli",
  "item.minecraft.skull_banner_pattern": "banner şablonu□kəllə şəkli",
  "item.minecraft.mojang_banner_pattern": "banner şablonu□şey",
  "item.minecraft.globe_banner_pattern": "banner şablonu□kürə",
  "item.minecraft.piglin_banner_pattern": "banner şablonu□donuz burnu",
  "block.minecraft.composter": "komposter",
  "block.minecraft.barrel": "çəllək",
  "block.minecraft.smoker": "şəhərim:",
  "block.minecraft.blast_furnace": "mədən sobası",
  "block.minecraft.cartography_table": "xəriteçi masası",
  "block.minecraft.fletching_table": "oxçu masası",
  "block.minecraft.grindstone": "i̇tiləmə",
  "block.minecraft.lectern": "kafedra",
  "block.minecraft.smithing_table": "dəmirçi masası",
  "block.minecraft.stonecutter": "turk meshurlar",
  "block.minecraft.bell": "zəng",
  "block.minecraft.lantern": "fənər",
  "block.minecraft.soul_lantern": "ruh fənəri",
  "item.minecraft.sweet_berries": "şirin giləmeyvə",
  "block.minecraft.campfire": "düşərgə tonqalı",
  "block.minecraft.soul_campfire": "ruh tonqalı",
  "block.minecraft.shroomlight": "göbələk lampası",
  "item.minecraft.honeycomb": "bal pətəyi",
  "block.minecraft.bee_nest": "arı yuvası",
  "block.minecraft.beehive": "arı pətəyi",
  "item.minecraft.honey_bottle": "bal butulkası",
  "block.minecraft.honey_block": "bal bloku",
  "block.minecraft.honeycomb_block": "bal pətəyi bloku",
  "block.minecraft.lodestone": "maqnitləşmis daş",
  "block.minecraft.netherite_block": "nezerit bloku",
  "block.minecraft.ancient_debris": "qədim qalıq",
  "block.minecraft.target": "hədəf",
  "block.minecraft.crying_obsidian": "ağlayan obsidian",
  "block.minecraft.blackstone": "qaradaş",
  "block.minecraft.blackstone_slab": "qaradaş pilləsi",
  "block.minecraft.blackstone_stairs": "qaradaş pilləkən",
  "block.minecraft.gilded_blackstone": "zərli qaradaş",
  "block.minecraft.polished_blackstone": "hamar qaradaş",
  "block.minecraft.polished_blackstone_slab": "hamar qaradaş pillə",
  "block.minecraft.polished_blackstone_stairs": "hamar qaradaş pilləkən",
  "block.minecraft.chiseled_polished_blackstone": "naxışlı hamar qaradaş",
  "block.minecraft.polished_blackstone_bricks": "hamar qaradaş kərpic",
  "block.minecraft.polished_blackstone_brick_slab": "hamar qaradaş kərpic pilləsi",
  "block.minecraft.polished_blackstone_brick_stairs": "hamar qaradaş kərpic pilləkən",
  "block.minecraft.cracked_polished_blackstone_bricks": "sınıq hamar qaradaş kərpic",
  "block.minecraft.respawn_anchor": "respaun mayakı",
}
export const az_az = items; 
